import { useState } from "react";
import { DraftBasketDrawer } from "../../pages/discovery/v2/distribution/DraftBasketDrawer";
import { useCanShowDeliveredBySellarOptionV2 } from "../../pages/discovery/v2/lib/useCanShowDeliveredBySellarOptionV2";
import {
  MenuDrawerListElement,
  MenuDrawerListElementIcon,
  MenuDrawerListElementLabel,
} from "../menu/MenuDrawerListElement";

export const SidebarDraftBaskets = () => {
  const [active, setActive] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const canShowDeliveredBySellar = useCanShowDeliveredBySellarOptionV2();

  return (
    <>
      <MenuDrawerListElement
        onClick={() => {
          setHasOpened(true);
          setActive(true);
        }}
      >
        <MenuDrawerListElementIcon icon="CART_OUTLINE" />
        <MenuDrawerListElementLabel>Draft baskets</MenuDrawerListElementLabel>
      </MenuDrawerListElement>
      {hasOpened && (
        <DraftBasketDrawer
          active={active}
          setActive={setActive}
          showDeliveredBySellarFeatures={canShowDeliveredBySellar}
        />
      )}
    </>
  );
};
